// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  occBaseSite: 'vsstore',

  occBaseUrl: 'https://api.valvstore.com',


  occPrefix: '/occ/v2/',
  deployPath: '',
  checkSSO: true,
  productSearchURL: '/occ/v2/vsstore/products/search',
  getQuoteURL: '/occ/v2/vsstore/users/',
  getQuoteURL1: '/rfqcart/getquote',
  quoteEntryURL1: '/occ/v2/vsstore/users/',
  quoteEntryURL2: '/rfqcart/',
  quoteEntryURL3: '/entries',
  getCountryURL: '/occ/v2/vsstore/countries/',
  masoSvi3:
    'https://valves.bakerhughes.com/digital-valve-positionersmasoneilan-svi3-digital-valve-positioner',
  consMpvSeries:
    'https://valves.bakerhughes.com/consolidatedpilot-operated-safety-relief-valvesconsolidated-type-2900-pilot-operated-safety-relief',
  bhValves: 'https://valves.bakerhughes.com/',
  channelConnect: 'https://www.bhchannelconnect.com/',
  // registerUrl: 'https://register.bakerhughesds.com/register/user/setup',
  registerUrl:
    'https://bhgeregister.cd8zy6g-bakerhugh1-d1-public.model-t.cc.commerce.ondemand.com/register/user/setup?registerFPTStore=true',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
